
export default {
  'orsDictionary': {
    'unknown': 'Inconnue',
    'paved': 'Pavée',
    'unpaved': 'Non pavée',
    'asphalt': 'Asphalte',
    'concrete': 'Béton',
    'cobblestone': 'Pierres',
    'metal': 'Métal',
    'wood': 'Bois',
    'compactedGravel': 'Gravier compacté',
    'fineGravel': 'Gravier fin',
    'gravel': 'Gravier',
    'dirt': 'Chemin de terre',
    'ground': 'Terre',
    'ice': 'Glace',
    'pavingStones': 'Pavés',
    'sand': 'Sable',
    'woodchips': 'Les copeaux de bois',
    'grass': 'Gazon',
    'grassPaver': 'Pavé de gazon',
    'none': 'Aucune',
    'no': 'Non',
    'customers': 'Clients',
    'destination': 'Destination',
    'delivery': 'Livraison',
    'private': 'Accès privé',
    'permissive': 'Permissive',
    'stateRoad': 'Route nationale',
    'road': 'Route',
    'street': 'Rue',
    'path': 'Chemin',
    'track': 'Pister',
    'cycleway': 'Piste cyclable',
    'footway': 'Sentier',
    'steps': 'Marches',
    'ferry': 'Ferry',
    'construction': 'Construction',
    'concrete:lanes': 'Voies en béton',
    'paving_stones': 'Pavés',
    'sett': 'Sett',
    'unhewn_cobblestone': 'Pavé non taillé',
    'compacted': 'Compacté',
    'fine_gravel': 'Gravier finl',
    'pebblestone': 'Galets',
    'impassable': 'Infranchissable',
    'very_horrible': 'Très horrible',
    'horrible': 'Horrible',
    'very_bad': 'Très mauvais',
    'bad': 'Mauvais',
    'intermediate': 'Intermédiaire',
    'good': 'Bonne',
    'excellent': 'Excellent',
    'grade1': 'Classe 1',
    'grade2': 'Classe 2',
    'grade3': 'Classe 3',
    'grade4': 'Classe 4',
    'grade5': 'Classe 5',

    'no_tollway': 'Pas de péage',
    'is_tollway': 'Péage',
    'no_category': 'Aucune catégorie',
    'highway': 'Autoroute',
    'unpaved_road': 'Route non pavé',
    'tunnel': 'Tunnel',
    'paved_road': 'Route pavé',
    'ford': 'Gué',
    'no_data': 'Pas de données'
  }
}